import { Component, NgModule, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';


import * as _ from 'lodash';
import { LanguageService } from '../../../services/LanguageService';
import { GuestsService } from '../../../services/GuestsService';
import { AuthServiceGuest } from '../../../services/AuthServiceGuest';
import { CurrentUser } from '../../../dataTypes/CurrentUser';
import { Company } from '../../../dataTypes/GuestSubsCompany';
import { MobileStatusService } from '../../../services/MobileStatusService';
import { AfterViewInit } from '@angular/core';
import { TranslationService } from '../../../shared/services/transalationService';
import { environment } from '../../../../environments/environment.prod';
import { now } from 'moment';

@Component({
  selector: 'companies-side-menu',
  templateUrl: './sideMenu.html',
  styleUrls: ['./sideMenu.css']
})
export class SideMenuComponent implements AfterViewInit, OnDestroy {

  public _user: CurrentUser;
  public _companiesList: Company[];
  public _companiesListBackup: Company[];

  //-------
  useMobileByForce: boolean = environment.useMobileOnly;
  public _isMobile: boolean = false;
  private _isRealyMobileDevice: boolean = false;

  public _screenSize: { width: number; height: number } = {
    width: 0,
    height: 0
  };

  public _screenTitle: string;

  public _isVertical: boolean = false; // Add the isVertical flag Horizontal

  //--------

  constructor(public _router: Router,
    private _language: LanguageService,
    private _GuestsService: GuestsService,
    private _AuthService: AuthServiceGuest,
    private _translationService: TranslationService,
    private mobileStatusService: MobileStatusService) {
      this._AuthService.userModel$.subscribe(userModel => {
        this._user = userModel;
      });

      _language.setLanguage('he');
  }

  ngOnInit(): void {

    this.updateOrientation();
    window.addEventListener('resize', this.updateOrientation.bind(this));

    const self = this;

    //-------------
    //+++++++++++++++
    this._isRealyMobileDevice = this.isRealyMobileDevice();
    console.log(this._isRealyMobileDevice);
    //+++++++++++++++

    this._isMobile = this.isMobileDevice();
    /////this._isMobile = (this.useMobileByForce === false) ? window.matchMedia('(max-width: 767px)').matches : true;
    /////this._isMobile = window.matchMedia('(max-width: 767px)').matches;
    /////this._isMobile = true; // true ->> for similate on PC the Mobile version
    console.log('sideMenu ngOnInit ' + this._isMobile ? 'Mobile' : 'Desktop');
    //--------------

    self._user = self._AuthService.getUserInfo();

    if (self._user) {

      self.getCompanies();
      
    }
  }

  updateOrientation() {
    this._isVertical = window.matchMedia('(orientation: portrait)').matches;
  }


  //+++++++++++++++++++++++++++++
  private isRealyMobileDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      /android|webos|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent)
    );
  }
  //+++++++++++++++++++++++++++++


  isMobileDevice(): boolean {

    this.getScreenSize();
    console.log('sideMenu isMobileDevice screenSize.width ' +this._screenSize.width);

    return this._isRealyMobileDevice ? true
      : this.useMobileByForce === false ? this._screenSize.width < this._screenSize.height
        : true;
  }

  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      this._isMobile = this.isMobileDevice();
      //this._isMobile = (this.useMobileByForce === false) ? window.matchMedia('(max-width: 767px)').matches : true;
      //this._isMobile = window.matchMedia('(max-width: 767px)').matches;
      //this._isMobile = true;
      const now = new Date();
      console.log('SideMenu setTimeout 0 .....' + now);
      //console.log(Date.now);
      this.mobileStatusService.setMobileStatus(this._isMobile);
    }, 0);

    //----------
    setTimeout(() => {
      this._screenTitle = this.getScreenTitle();
      const now = new Date();
      try {
        if (typeof this._screenTitle !== 'undefined') {
          let size = this._screenTitle.length;
          console.log('sideMenu ScreenTitle size ' + size + ' Timestamp: ' + now.toISOString());
        }

      } catch (e) {
        console.error(e);
      }
    }, 50);
    //-----------
  }


  getScreenSize() {
    this._screenSize = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  getScreenTitle(): string {
    const self = this;
    const userInfo = self._AuthService.getUserInfo();

    self._GuestsService.getCompanies(userInfo.Id);
    try {
      let cn: string = "";
      if (typeof self._GuestsService._selectedCompany !== 'undefined')
        cn = self._GuestsService._selectedCompany.name;
      const authenticatedUser: string = this._translationService.translate("AuthenticatedUser");
      const company: string = this._translationService.translate("GuestsCompany");
      const companyName: string = cn;
      //const ltd: string = this._translationService.translate("Ltd") ${ltd}
      let buff:string = `${authenticatedUser}: ${userInfo.Name} ${company} ${companyName} `
      return buff;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  //-----------

  getCompanies(){

    const self = this;
    console.log("sideMenu Get companies");
    self._GuestsService.getCompanies(self._user.Id)
      .subscribe((data: Company[]) => {
        if (data) {
          self._companiesList = data;
          self._companiesListBackup = self._companiesList;

          self._GuestsService._companiesList = data;

          if (self._companiesList.length > 0) {
            self._GuestsService.setSelectedCompany(self._companiesList[0]);
          }

        }
      },
        error => { console.error("getCompanies Error"); }
      );
  }
  isSelected(company: Company) {
    const self = this;

    if (company.id === self._GuestsService._selectedCompany.id) return true;
    else return false;
  }
  onCompanyClick(company: Company) {

    const self = this;
    console.log('sideMenu onCompanyClick');
    self._GuestsService.setSelectedCompany(company);
    this._screenTitle = this.getScreenTitle();
  }

  //onOpenedChange()
  OnSideMenuOpen() {
    //const curr = this._router.getCurrentNavigation;
    console.log('------- sideMenu OnSideMenuOpen ---------- ');
    //this._router.navigate(['/guest']);
}

  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;

    console.log('sideMenu applyFilter filterValue ' + filterValue);

    if (filterValue.length === 0) {

      this._companiesList = this._companiesListBackup;
    }
    else {
      this._companiesList =
        this._companiesListBackup.filter(
          ttt => ttt.name.toLowerCase().includes(filterValue.toLowerCase()));
    }
  }
  OnLogout() {
    console.log('sideMenu Exit Logout')
    console.log('*** Logout to proceed ***');

    this._AuthService.logout();
  }
}
